// extracted by mini-css-extract-plugin
module.exports = {"Icon":"_38EpvQJ-yNP8zertp7k76I","Button":"Bpy7gYHsB4WmJvwTFyHfv"};